var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 16.92c0-3.27 2.1-6.07 5.03-7.14.36-.8.57-1.67.57-2.55C15 3.8 15 1 10.8 1S6.6 3.79 6.6 7.23c0 2.14 1.26 4.29 2.8 5.15v1.14C4.65 13.9 1 16.2 1 19h8.7a7.54 7.54 0 0 1-.3-2.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm4 6-3 3v-2.33h-5v-1.34h5V13.5l3 3.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEject);
export default ForwardRef;